export default "__VITE_ASSET__BtfdO6zv__"